export const CAMPAIGN_TYPES = {
  ONGOING: 'ongoing',
  ONE_OFF: 'one_off',
  RUNNING: 'running',
  EMAIL_TEMPLATES: "email_templates",
};
